// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"w0-z"};